export default __webpack_public_path__ + "static/media/GrowingIvy2.0c79bf23.png";